import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { RouterModule } from '@angular/router';

import { I18nModule } from '@app/i18n';
import { AuthModule } from '@app/auth';
import { ShellComponent } from './shell.component';
import { ButtonModule } from '@app/components/button/button.module';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MenuModule } from './menu/menu.module';
import { FooterModule } from './footer/footer.module';
import { HeaderModule } from './header/header.module';
import { CompanyBannerModule } from '@app/components/companyBanner/companyBanner.module';
import { ErrorDisplayModule } from '@app/components/errorDisplay/errorDisplay.module';

@NgModule({
  imports: [
    AuthModule,
    ButtonModule,
    CommonModule,
    FooterModule,
    HeaderModule,
    I18nModule,
    MatSidenavModule,
    MenuModule,
    RouterModule,
    TranslateModule,
    CompanyBannerModule,
    ErrorDisplayModule,
  ],
  declarations: [ShellComponent],
})
export class ShellModule {}
